<template>
  <v-ons-page>
    <ons-toolbar>
      <div class="center has-logo">
        <img :src="defaultLogo" class="toolbar-logo">
      </div>
      <div class="right">
        <v-ons-toolbar-button slot="right" modifier="white-content" @click="openMainMenu">
          <v-ons-icon icon="ion-navicon, material:md-menu"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </ons-toolbar>
    <v-ons-tabbar :index.sync="tabBarIndex"
            :swipeable="false"
            position="bottom"
            :tabs="tabs"
    >
    </v-ons-tabbar>

  </v-ons-page>

</template>

<script>
  import DashboardProjects from './DashboardProjects';
  import DashboardDocs from './DashboardDocs';
  import DashboardCalendar from './DashboardCalendar';
  import DashboardPhotos from './DashboardPhotos';

  export default {
    name: 'DashboardHome',
    data() {
      return {
        showingTip: false,
        animationOptions: {},
        tabBarIndex: 0,
        tabs: [
          {
            label: 'Events',
            icon: 'fa-calendar',
            active: true,
            page: DashboardCalendar,
          },
          {
            label: 'Albums',
            active: false,
            icon: 'fa-images',
            page: DashboardPhotos,
          },
          {
            label: 'Projects',
            active: false,
            icon: 'fa-project-diagram',
            page: DashboardProjects,
          },
          {
            label: 'Documents',
            active: false,
            icon: 'fa-file',
            page: DashboardDocs,
          },
        ]

      }
    },
    mounted() {
      //alert("Mounting");
    },
    computed: {
      defaultLogo(){
        return process.env.VUE_APP_VARIANT +`/img/logo.svg`
      },
      index: {
        get() {
          return this.$store.state.tabbar.index;
        },
        set(newValue) {
          this.$store.commit('tabbar/set', newValue)
        }
      },
      /*
      title() {
        return this.md ? 'Dashboard' : this.tabs[this.index].title || this.tabs[this.index].label;
      },
      */
    },
    methods: {
      openMainMenu() {
        this.$store.commit('splitter/toggle', true);
      }
    },
    watch : {
      tabBarIndex(newTabIndex){
        this.$store.commit('shared/setHomeTabIndex', newTabIndex);
      }
    }
  }



</script>
